<template>
  <div class="album">
    <tip></tip>
    <div class="conntent">
      <div class="thumb-example">
        <!-- swiper1 -->
        <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop" @click="showPopup" @slideChange="changeIndex" @touchEnd="touchEnd" @slideChangeTransitionEnd="PopHidden">
<!--          <swiper-slide class="slide-1 swiper-zoom-container">-->
<!--            <img :src="item.pic" alt="" class="gallery-img" draggable="false" />-->

<!--          </swiper-slide>-->
        </swiper>
      </div>
      <popup
          v-model="popupVisible"
          :modal="false"
          position="bottom" class="popthumbs">
        <div class="popmain">
          <div class="popmainHead">
            <div class="custom-pagination">当前页<span>{{parseInt(startIndex)+1|padZero}}</span>/{{videoList.length|padZero}}</div>
            <div class="transparent-button" @click="topageDetail(id)">图书详情</div>
          </div>

          <div class="item-box">
            <div class="item-list" v-for="(item, index) in videoList" :class="{ active: index == startIndex }" :key="index" @click="swiperTo(index,false)">
              <div class="cover_pic" >
                <img :src="item.pic" alt="">
              </div>
              <div class="item-name">{{index+1|padZero}}</div>
            </div>
            <div class="width20"></div>
          </div>
          <!-- swiper2 Thumbs -->
<!--          <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">-->
<!--            <swiper-slide class="slide-1" style="flex-direction: column;" v-for="(item, key) in videoList" :key="key" @click="swiperTo(key)">-->
<!--              <img :src="item.pic" alt="" />-->
<!--              <div class="thumb-index">{{ key + 1 }}</div>-->
<!--            </swiper-slide>-->

<!--          </swiper>-->
        </div>

      </popup>
    </div>
  </div>
</template>

<script>
import tip from '@/components/tip.vue';
import { Indicator,Popup,Toast } from 'mint-ui';
import wechat from "@/plugins/wx";
// 按需引入 Swiper 和 Vue 封装组件
import { Swiper} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css'; // 引入 Swiper 样式
// 安装模块
  export default {
    components: {
      tip,
      // Button,
      Swiper,
      //SwiperSlide,
      Popup,
    },
    data() {
      return {
        popupVisible:true,
        swiperOptionTop: {
          loop: false,
          //loopedSlides: 5, // looped slides should be the same
          spaceBetween: 10,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          pagination: {
            el: '.swiper-pagination', // 分页器
            type: 'fraction', // 显示页码（如 1/5）
            renderCustom: function (swiper, current, total) {
              return current + ' of ' + total;
            }
          },
          initialSlide:0,
          zoom: true, // 启用缩放功能
          virtual: {
            slides: [],
            // renderSlide: function (slide) {
            //   return `<img src="${slide}" alt="" class="gallery-img" draggable="false" />`
            // }
            renderSlide: function (slide) {
              return `
    <div class="slide-1 swiper-zoom-container swiper-slide" style="width: 100%">
      <img src="${slide}" alt="" class="gallery-img" draggable="false" />
    </div>
  `
            }


          },

        },
        swiperOptionThumbs: {
          loop: false,
          //loopedSlides: 5, // looped slides should be the same
          spaceBetween: 10,
          //centeredSlides: true,
          slidesPerView: 'auto',
          touchRatio: 0,
          initialSlide: 3,
          // freeMode: true,
          // slidesPerView: 4,
          //slideToClickedSlide: true,
          watchSlidesVisibility: true,//防止不可点击

        },
        videoObj: {
        title: '分享标题',
        intro:"简洁",
        author_pic:"xxxxx",
        author_name:"作者",
        video_count:20,
        },
        videoList: [],
        id: 0,
        startIndex:0,
        iszhankai: false,
        shareConfig: {
          title: '分享标题',
          desc: '这是一个测试的微信分享',
          link: '', // 分享链接
          imgUrl: '', // 分享图标
        },
        isLastSlide:false,
      }
    },
    filters: {
      // 补零过滤器
      padZero(num) {
        return num < 10 ? `0${num}` : num;
      },
    },
    computed: {
      swiper(){
        return this.$refs.swiperTop.$swiper;
      }
    },
    mounted() {
      this.$nextTick(() => {
        // const swiperTop = this.$refs.swiperTop.$swiper
        // const swiperThumbs = this.$refs.swiperThumbs.$swiper
        //swiperTop.controller.control = swiperThumbs
        //swiperThumbs.controller.control = swiperTop
        
        // 初始化时滚动active元素到视图中
        setTimeout(() => {
          this.scrollActiveItemIntoView();
        }, 300); // 延迟一点时间确保DOM已完全渲染
      })
    },
    created () {
      //this.getVideoList()
      this.getGallery()
    },
    methods: {
      changeIndex() {
        //this.startIndex = index;
        const swiperTop = this.$refs.swiperTop.$swiper
        this.startIndex = swiperTop.activeIndex;
        // if(swiperTop.activeIndex == this.videoList.length-1){
        //
        // }
        // if(this.popupVisible){
        //   this.popupVisible=false;
        // }
        if (swiperTop.isEnd) {
          this.isLastSlide = true;
        } else {
          this.isLastSlide = false;
        }
        
        // 滚动active元素到视图中
        this.$nextTick(() => {
          this.scrollActiveItemIntoView();
        });
      },
      onReachEnd() {
        this.isLastSlide = true;
      },
      // 监听 Slide 切换
      onSlideChange() {
        if (this.swiper.isEnd) {
          this.isLastSlide = true;
        } else {
          this.isLastSlide = false;
        }
      },
      touchEnd(){
        //
        if(this.popupVisible){
          //this.popupVisible=false;
          console.log("这里赋值为false",false)
        }
        const swiperTop = this.$refs.swiperTop.$swiper;

        if(swiperTop.realIndex == this.videoList.length-1&&swiperTop.isEnd){
          let l = swiperTop.getTranslate()
          if (!Number.isInteger(l)){
            Toast({
              message:'当前已经是最后一页了',
              duration: 1000,
              className: 'custom-toast'
            });
          }

        }

      },
      swiperTo(index,init){
        this.startIndex = index;
        const swiperTop = this.$refs.swiperTop.$swiper
        swiperTop.slideTo(index);

        if(!init){
          //this.showPopup();
        }else{
          this.popupVisible=true;
        }
        
        // 滚动active元素到视图中
        this.$nextTick(() => {
          this.scrollActiveItemIntoView();
        });
      },
      
      // 滚动active元素到视图中的方法
      scrollActiveItemIntoView() {
        const activeItem = document.querySelector('.item-list.active');
        if (activeItem) {
          // 计算滚动位置，使active元素居中显示
          const itemBox = document.querySelector('.item-box');
          const itemBoxWidth = itemBox.offsetWidth;
          const activeItemLeft = activeItem.offsetLeft;
          const activeItemWidth = activeItem.offsetWidth;
          
          // 计算滚动位置，使active元素居中
          const scrollLeft = activeItemLeft - (itemBoxWidth / 2) + (activeItemWidth / 2);
          
          // 平滑滚动到计算的位置
          itemBox.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
          });
        }
      },
      async report(id,dt) {
        try {
          // 发送点击事件请求到服务端
          await this.$report.sendReport({
            "id": id,
            "dt":dt
          });

        } catch (error) {
          console.error("Error sending click request:", error);
        }
      },
      topage(){
        this.$router.push(`/videoList?id=${this.id}`)
      },
      topageDetail(id){
        this.$router.push(`/gallery?id=${id}`)
      },
      zhankaiFn(){
        this.iszhankai = !this.iszhankai
      },
      onSwiper (swiper) {
        console.log(swiper);
      },
      showPopup(event){

        // const swiperTop = this.$refs.swiperTop.$swiper;
        // let l = swiperTop.getTranslate()
        // console.log('开始',l)
        // if (!Number.isInteger(l)){
        //   return
        // }
        console.log('1',this.popupVisible,event);
        if(this.popupVisible){
          this.popupVisible=false;
        }else {
          this.popupVisible=true;
          this.$nextTick(() => {
          this.scrollActiveItemIntoView();
        });
        }
        console.log(2,this.popupVisible);

      },
      PopHidden(){
        this.popupVisible=false;
      },
      // onSlideChange () {
      //   console.log('slide change');
      // },
      async getVideoList() {
        try {
          Indicator.open()
          this.id = this.$route.query.id || 1
          this.swiperOptionTop.initialSlide = this.$route.query.start || 1
          this.swiperOptionThumbs.initialSlide = this.$route.query.start || 1

          const res = await this.axios.get(`https://new-videoapi.ayerdudu.com/val_${this.id}.html`)
          //this.videoObj = res.data
          const currentUrl = window.location.href.split('#')[0];
          this.shareConfig.title = this.videoObj.title;
          this.shareConfig.desc = this.videoObj.intro;
          this.shareConfig.link = currentUrl;
          this.shareConfig.imgUrl = this.videoObj.surface_pic;
          //const currentUrl = 'http://videos.ayerdudu.com/audioDetail?id=d1b469a1-91f4-1400-d29e-241571036c3c';
          wechat.initConfig(currentUrl).then(() => {
            // 配置分享内容
            wechat.setShareOptions(this.shareConfig);
          });
          this.videoList = res.data.video_list
          Indicator.close()
        } catch (err) {
          Indicator.close()
          console.log(err)
        }
      },
      async getGallery() {
        try {
          Indicator.open()
          this.id = this.$route.query.id || 1

          const res = await this.axios.get(`https://api.ayerdudu.com/v1/galleryImg/list?gid=${this.id}&sort=asc`)
          //this.videoObj = res.data
          const currentUrl = window.location.href.split('#')[0];
          // this.shareConfig.title = this.videoObj.title;
          // this.shareConfig.desc = this.videoObj.intro;
          this.shareConfig.link = currentUrl;
          //this.shareConfig.imgUrl = this.videoObj.surface_pic;
          console.log('分享配置',this.shareConfig);
          //const currentUrl = 'http://videos.ayerdudu.com/audioDetail?id=d1b469a1-91f4-1400-d29e-241571036c3c';
          wechat.initConfig(currentUrl).then(() => {
            // 配置分享内容
            wechat.setShareOptions(this.shareConfig);
          });
          console.log('res-----',res);
          console.log('sssssss',this.swiper);
          res.data.data.forEach((item) => {
            if(!item.enable){
              this.swiper.virtual.appendSlide(item.pic);
              this.videoList.push(item);
            }
          })

          this.swiperOptionTop.initialSlide = this.$route.query.start || 0
          this.swiperOptionThumbs.initialSlide = this.$route.query.start || 0
          this.startIndex = this.$route.query.start || 0
          this.swiperTo(this.startIndex,true);
          //this.popupVisible = true;
          console.log("起始",this.swiperOptionThumbs.initialSlide, this.swiperOptionTop.initialSlide,this.popupVisible)
          
          // 数据加载完成后，确保active元素滚动到视图中
          this.$nextTick(() => {
            setTimeout(() => {
              this.scrollActiveItemIntoView();
            }, 300); // 延迟一点时间确保DOM已完全渲染
          });
          
          Indicator.close()
        } catch (err) {
          Indicator.close()
          console.log(err)
        }
      }
    }
  }
</script>

<style lang="less" scoped>
.album{
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  //overflow: hidden;
  //overflow-y: scroll;
  background-color: #000000;

  &::-webkit-scrollbar {
    display: none;
  }
  .conntent{
    position: relative;
    height: 100%;
    background: #fff;
    //margin-top: calc(100vw * (110 / 750));
    flex: 1; /* 让 conntent 占据剩余空间 */
    display: flex;
    flex-direction: column;
    justify-content: space-between; /* 将内容推到底部 */
    //padding-bottom: 28px;
    //padding-top: 28px;
    .big-img{
      width: 363px;
      height: 363px;
      margin: 0 auto 28px;
      position: relative;
      overflow: hidden;
      border-radius: 20px;
      // border: 1px solid #eee;
      box-shadow:0px 1px 4px rgba(0,0,0,0.3),0 0 40px rgba(0,0,0,0.1) inset;
      // webkit-box-shadow:0px 1px 4px rgba(0,0,0,0.3),0 0 40px rgba(0,0,0,0.1) inset;
      // moz-box-shadow:0px 1px 4px rgba(0,0,0,0.3),0 0 40px rgba(0,0,0,0.1) inset;
      // o-box-shadow:0px 1px 4px rgba(0,0,0,0.3),0 0 40px rgba(0,0,0,0.1) inset;
      img{
        width: 100%;
        height: 100%;
      }
      .zhuanjie{
        position: absolute;
        top: -57px;
        right: -53px;
        background: #22b07d;
        color: #fff;
        width: 120px;
        height: 120px;
        border-radius: 50%;
        line-height: 174px;
        font-size: 24px;
        text-indent: 10px;
      }
    }
    .title{
      line-height: 54px;
      font-size: 36px;
      text-align: center;
      padding: 0 40px;
      font-weight: bold;
    }
    .author_info{
      height: 46px;
      overflow: hidden;
      position: relative;
      margin: 25px 0 20px 0;
      .span_info{
        display: inline-block;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
      }
      .span-img{
        float: left;
        width: 46px;
        height: 46px;
        img{
          width: 100%;
          height: 100%;
          border-radius: 50%;
          box-shadow: 1px solid #bfbfbf;
        }
        margin-right: 12px;
      }
      .auther{
        float: left;
        height: 46px;
        font-size: 26px;
        line-height: 55px;
      }
    }
  }
.synopsis{
  font-size: 24px;
  color: #888;
  line-height: 36px;
  display: flex;
  padding: 0 38px;
  .synopsis-text{
    flex: 1;
    line-height: 37px;
    &.zhankai{
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
  >span{
    width: 20px;
    position: relative;
    cursor: pointer;
    >img{
      width: 30px;
      height: 30px;
      position: absolute;
      bottom: 0;
    }
  }
}
.item-box{
  //margin-top: 28px;
  height: 270px;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  overflow-x: scroll;
  margin-bottom: 75px;
  margin-left: 20px;
  &::-webkit-scrollbar {
    display: none;
  }
  .width20{
    display: inline-block;
    height: 268px;
    width: 40px;
    vertical-align: top; // 此处新增
  }
  .item-list{
    display: inline-block;
    height: 268px;
    width: 120px;
    overflow: hidden;
    //border-radius: 10px;
    margin-right: 30px;
    //background: #fff;
    position: relative;
    vertical-align: top; // 此处新增
    padding-right: 8px;
    .min{
      position: absolute;
      display: inline-block;
      top: 120px;
      right: 11px;
      font-size: 24px;
      background: rgba(0, 0, 0, .3);
      border-radius: 14px;
      color: #fff;
      padding: 0 12px;
      height: 32px;
      line-height: 32px;
      vertical-align: middle; // 此处新增
    }
    .cover_pic{
      display: block;
      width: 100%;
      //height: 160px;
      position: relative;
      //overflow: hidden;
      overflow: visible; /* 确保父元素不剪裁子元素 */
      padding: 4px; /* 移除或调整padding */
      margin: 0;
      //box-shadow: 1px solid #bfbfbf;
      img{
        width: 100%;
        height: 100%;
        max-height: 160px;
        max-width: 120px;
        object-fit: cover;
      }
    }
    .name{
      font-size: 26px;
    }
    .item-name{
      box-sizing: border-box;
      display: inline-block;
      overflow: hidden;
      //padding: 17px 17px 20px;
      padding: 22px 4px;
      height: 85px;
      font-size: 25px;
      line-height: 36px;
      white-space: normal;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      vertical-align: top; // 此处新增
      color: white;
    }
    .mengceng{
      display: none;
    }
    &.active{
      .item-name{
        color: #5eb8ff;

      }
      .cover_pic>img{
        outline: #5eb8ff solid 4px;
      }
      .mengceng{
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background:rgba(0, 0, 0, 0.25);
      }
    }
  }
  
}
}
.videoList-box{
  background: #fff;
}
.videoList{
  padding-left: 36px;
  background: #f6f6f6;
  padding-bottom: 40px;
  border-radius: 30px 30px 0 0;
  .video_count{
    font-size: 32px;
    font-weight: bold;
    height: 110px;
    line-height: 130px;
  }
  .segmen_name{
    display: inline-block;
    height: 48px;
    font-size: 26px;
    font-weight: bold;
    line-height: 48px;
    background: #fff;
    padding: 0 25px 0 17px;
    border-radius: 10px;
    position: relative;
    &::before{
      content: '';
      display: inline-block;
      width: 6px;
      height: 24px;
      position: absolute;
      top: 50%;
      left: 0;
      margin-top: -12px;
      background: #f6451b;
      border-radius: 3px;
    }
  }
}
.xiajia{
  font-size: 26px;
  text-align: center;
  line-height: 50px;
}

</style>
<style>
.custom-toast{
  width: 292px !important; /* 宽度 */
  height: 64px !important; /* 高度 */
  border-radius: 5px !important; /* 圆角 */
  background-color: #393939 !important; /* 背景色 */
  font-size: 24px !important; /* 字体大小 */
  color: #ffffff !important; /* 字体颜色 */
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.custom-toast span{
  font-size: 24px !important;
}
</style>
<style lang="less" scoped>
  // 定义变量
@black: #000000; // 黑色
@gap: 10px; // 间距

// 容器样式
.thumb-example {
  //height: 100vw;
  flex: 1; /* 让 thumb-example 占据剩余空间 */
  height: 100%;
  background-color: @black;
}

// Swiper 样式
.swiper {
  .swiper-slide {
    background-size: cover;
    //background-position: center;

    // 不同幻灯片的背景图片
    &.slide-1 >img {
      width:100%;
      height:100%;
      max-width: 100%;
      max-height: 100%;
      -o-object-fit: contain;
      object-fit: contain
      //background-image: url('https://yuntisyscdn.bookln.cn/server/resource/pdf/128407077/13993513/2505918/13993513_3_FCE56A82187DA46190E12AC089DA5027.jpg?_width=1488&_height=2086');
    }
    //&.slide-2 {
    //  background-image: url('https://yuntisyscdn.bookln.cn/server/resource/pdf/128407077/13993513/2505918/13993513_2_089D77FC94CD04CA9C91ED5E655EEC47.jpg?_width=1488&_height=2086');
    //}
    //&.slide-3 {
    //  background-image: url('https://yuntisyscdn.bookln.cn/server/resource/pdf/128407077/13993513/2505918/13993513_3_FCE56A82187DA46190E12AC089DA5027.jpg?_width=1488&_height=2086');
    //}
    //&.slide-4 {
    //  background-image: url('https://yuntisyscdn.bookln.cn/server/resource/pdf/128407077/13993513/2505918/13993513_2_089D77FC94CD04CA9C91ED5E655EEC47.jpg?_width=1488&_height=2086');
    //}
    //&.slide-5 {
    //  background-image: url('https://yuntisyscdn.bookln.cn/server/resource/pdf/128407077/13993513/2505918/13993513_3_FCE56A82187DA46190E12AC089DA5027.jpg?_width=1488&_height=2086');
    //}
  }

  // 顶部画廊样式
  &.gallery-top {
    height: 100%;
    width: 100%;
  }

  // 缩略图画廊样式
  &.gallery-thumbs {
    height: 80%;
    box-sizing: border-box;
    padding: @gap 0;
    overflow-x: auto;
    //order: 2;
    //display: flex;
    //flex-direction: column;
    //align-items: center;
    .swiper-slide {
      width: 25%;
      height: 100%;
      opacity: 0.4;
      display: flex;
      align-items: center;
      justify-content: center;
      // 激活状态的缩略图
      &.swiper-slide-active {
        opacity: 1;
      }
    }
  }
}
  //.swiper-pagination {
  //  position: absolute;
  //  bottom: 10px;
  //  left: 50%;
  //  transform: translateX(-50%);
  //  z-index: 10;
  //  color: white;
  //  font-size: 16px;
  //}
  .popthumbs{
    background: rgba(0, 0, 0, 0.7);
    width: 100%;
    //height: 25%; /* 设置高度为 20% */
    height: 382px;
    //display: flex;
    //flex-direction: column;
    //align-items: center; // 居中对齐
    //padding: 10px 0;
  }
  .popthumbs .swiper-pagination {
    font-size: 32px;
    color: #fff;
    text-align: left;
    display: flex;
    align-items: center;
    bottom: 0px;
    position: relative;
    margin-left: 20px;
  }
  .custom-pagination {
    font-size: 24px;
    color: #fff;
    text-align: left;
    display: flex;
    align-items: center;
    //bottom: 0px;
    position: relative;
    margin-left: 40px;
    //margin-top: 32px;
    justify-content: center;
    //height: 28px;
  }
  .custom-pagination span {
    background-color: white; /* 白色背景 */
    color: black; /* 黑色字体 */
    width: 60px; /* 宽度 */
    height: 28px; /* 高度 */
    display: flex; /* 使用 Flexbox 布局 */
    align-items: center; /* 垂直居中 */
    justify-content: center; /* 水平居中 */
    margin: 0 8px; /* 与文字的间距 */
    border-radius: 4px; /* 可选：添加圆角 */
  }
  .page-read-bottom {
    position: fixed;
    //z-index: 20;
    //background: rgba(0, 0, 0, 0.7);
    bottom: 0;
    width: 100%;
    height: 20%; /* 设置高度为 20% */
    display: flex;
    flex-direction: column; /* 垂直排列子元素 */
    justify-content: space-between; /* 顶部和底部对齐 */
    //position: absolute;
    //bottom: 0;
    //left: 0;
    //right: 0;
    //background: rgba(0, 0, 0, 0.7);
    //z-index: 20;
    //padding: 10px;
    //box-sizing: border-box;
  }

  /* swiper-pagination 和 pdf-opt-btn 放置在顶部 */
  .page-read-bottom .swiper-pagination,
  .page-read-bottom .pdf-opt-btn {
    position: static; /* 取消绝对定位 */
    width: 100%;
    padding: 10px; /* 根据需要调整内边距 */
    box-sizing: border-box;
  }

  /* swiper-pagination 样式 */
  .page-read-bottom .swiper-pagination {
    font-size: 32px;
    color: #fff;
    text-align: left;
    display: flex;
    align-items: center;
  }

  /* pdf-opt-btn 样式 */
  .page-read-bottom .pdf-opt-btn {
    display: flex;
    justify-content: flex-end; /* 按钮靠右 */
    align-items: center;
  }

  /* gallery-thumbs 放置在底部 */
  .page-read-bottom .gallery-thumbs {
    width: 100%;
    height: 60%; /* 占据剩余空间 */
    box-sizing: border-box;
    padding: 10px 0; /* 根据需要调整内边距 */
  }
  /* line 97, ../../sass/res/pdf.scss */
  .page-read-bottom .pdf-opt-btn .download-print-wrapper {
    margin-left: 0.32rem;
    position: relative;
    z-index: 12;
  }
  /* line 102, ../../sass/res/pdf.scss */
  .page-read-bottom .pdf-opt-btn .download-pdf, .page-read-bottom .pdf-opt-btn .fav-pdf {
    height: 0.74667rem;
    font-size: 0.37333rem;
    color: #fff;
    z-index: 11;
    margin-left: 0.32rem;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    -webkit-align-items: center;
  }
  /* line 112, ../../sass/res/pdf.scss */
  .page-read-bottom .pdf-opt-btn .download-pdf img, .page-read-bottom .pdf-opt-btn .fav-pdf img {
    width: 0.64rem;
    height: 0.64rem;
    margin-right: 0.05333rem;
  }
  /* line 118, ../../sass/res/pdf.scss */
  .page-read-bottom .pdf-opt-btn :first-child {
    margin-left: 0;
  }
  .thumb-item {
    display: flex;
    flex-direction: column;
    //align-items: center;
    //justify-content: center;
  }

  //.thumb-item img {
  //  width: 100%;
  //  max-width: 80px; // 控制缩略图大小
  //  height: auto;
  //}

  .thumb-index {
    margin-top: 5px;
    font-size: 32px;
    color: #fff;
    text-align: center;
  }
  .popmain{
    display: flex;
    flex-direction: column; /* 设置为主轴为垂直方向 */
  }
  .popmainHead{
    display: flex;
    justify-content: space-between;
    height: 112px;
    align-items: center; /* 垂直居中 */
    //padding: 42px 40px;
  }

  .transparent-button {
    //background-color: transparent; /* 设置背景颜色为透明 */
    //border: 2px solid #ffffff; /* 设置边框颜色和宽度 */
    //color: #ffffff; /* 设置文字颜色 */
    ////padding: 10px 20px; /* 设置内边距 */
    ////font-size: 32px; /* 设置字体大小 */
    //border-radius: 8px;
    //width: 120px;
    //
    ////width: 30%;
    ////cursor: pointer; /* 设置鼠标悬停时的光标样式 */
    ////position: absolute;
    ////display: inline-block;
    //display: flex;
    ////top: 120px;
    ////right: 11px;
    //font-size: 18px;
    //height: 46px;
    ////border-radius: 14px;
    //color: #fff;
    ////padding: 60px 23px;
    ////height: 32px;
    ////line-height: 32px;
    //vertical-align: middle; // 此处新增
    //margin-right: 72px;
    //margin-top: 32px;
    //margin-bottom: 44px;
    ////text-align: center;
    //justify-content: center; /* 水平居中 */
    //align-items: center;

    margin-right: 72px; /* 右边距 */
    border: 2px solid #ffffff; /* 边框 */
    height: 46px; /* 高度 */
    width: 120px; /* 宽度 */
    display: flex; /* 使用 Flexbox 布局 */
    align-items: center; /* 垂直居中 */
    justify-content: center; /* 水平居中 */
    margin-top: 33px; /* 上边距 */
    margin-bottom: 33px; /* 下边距 */
    font-size: 20px; /* 文字大小 */
    cursor: pointer; /* 鼠标悬停时显示手型 */
    background-color: transparent; /* 透明背景 */
    border-radius: 28px; /* 可选：添加圆角 */
    color: #ffffff;

  }
  .gallery-img{
    -webkit-user-select: none; /* 禁止文字选中 */
    -webkit-touch-callout: none; /* 禁止长按菜单 */
    user-select: none;
    pointer-events: none;
  }
  .imgbox{
    position: relative;
    width: 80%;
    margin: 0 auto;
    margin-top: 20px;
  }
  .imgbox .imshar{
    position: absolute;
    z-index: 100;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    opacity: 0;
  }
  .imgbox img{
    display: block;
    width: 100%;
  }
</style>